export const FETCH_COMMUNICATION_PREFERENCES_MASKED = "FETCH_COMMUNICATION_PREFERENCES_MASKED";
export const FETCH_COMMUNICATION_PREFERENCES_UNMASKED = "FETCH_COMMUNICATION_PREFERENCES_UNMASKED";
export const SET_COMMUNICATION_PREFERENCES = "SET_COMMUNICATION_PREFERENCES";
export const UPDATE_ALERT_PREFERENCES_LIST = "UPDATE_ALERT_PREFERENCES_LIST";
export const SET_ALERT_TYPES = "SET_ALERT_TYPES";
export const FETCH_ALERT_TYPES = "FETCH_ALERT_TYPES";
export const FETCH_COMMUNICATION_PREFERENCES_FAILED = "FETCH_COMMUNICATION_PREFERENCES_FAILED";
export const FETCH_COMMUNICATION_PREFERENCES_SUCCESS = "FETCH_COMMUNICATION_PREFERENCES_SUCCESS";
export const SET_EDITABLE_MODE = "SET_EDITABLE_MODE";
export const SET_ALERT_TYPES_FAILED = "SET_ALERT_TYPES_FAILED";
export const SET_ALERT_TYPES_SUCCESS = "SET_ALERT_TYPES_SUCCESS";
export const RESET_ALERT_PREFERENCES = "RESET_ALERT_PREFERENCES";
export const RESET_COMMUNICATION_PREFERENCES = "RESET_COMMUNICATION_PREFERENCES";
export const SET_PREFERECES_DETAILS = "SET_PREFERECES_DETAILS";

export const updateAlertPreferencesList = (payload) => ({
  type: UPDATE_ALERT_PREFERENCES_LIST,
  payload
});

export const setEditableMode = (isSso) => (
{
  type: SET_EDITABLE_MODE,
  isSso
});

export const resetAlertPreferences = () => ({
  type: RESET_ALERT_PREFERENCES
});

export const resetCommunicationPreferences = () => ({
  type: RESET_COMMUNICATION_PREFERENCES
});

export const setPreferenceDetails = (payload) => {
  return {
  type: SET_PREFERECES_DETAILS,
  payload
}};
